import { createPortal } from 'react-dom';

/**
 * Un écran qui couvre tout le téléphone, au-dessus de l'en-tête et des onglets.
 *
 * <p>Rendu dans le contenu de la page, un écran en `position: fixed` restait
 * pris sous l'en-tête de SwissTech sur l'iPhone : ses boutons du haut étaient
 * cachés et la page ne défilait plus (catalogue du magasin). Posé directement
 * dans le document, il couvre vraiment tout l'écran. La visionneuse des PDF
 * (z-index 10000) passe toujours par-dessus.
 *
 * @param {object} props propriétés
 * @param {import('react').ReactNode} props.children l'écran
 * @returns {import('react').ReactPortal|import('react').ReactNode} l'écran, posé dans le document
 */
export function PleinEcran({ children }) {
  if (typeof document === 'undefined' || !document.body) return children;
  return createPortal(children, document.body);
}
